"use strict";
exports.__esModule = true;
var angular = require("angular");
var tornado_chart_maker_1 = require("../tornado/app/js/logic/tornado-chart-maker");
var tornado_logic_1 = require("../tornado/app/js/logic/tornado-logic");
var ScoringComponent = /** @class */ (function () {
    function ScoringComponent($rootScope, $scope, $timeout) {
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $scope.$on('command:SCORING', function (event, args) {
            ctrl.initComponent(event, args);
            $scope.$emit('workbench:loading', { 'load': false });
            if (args.actionMenuItem == 'Impact Board' || args.actionMenuItem == 'Impact Scoring') {
                ctrl.showTornado(args);
            }
        });
        $scope.$on('command:ISSUE_SCANNING', function (event, args) {
            ctrl.title = "Business Model Canvas";
            ctrl.node = args.node;
            ctrl.nodeName = args.node.name;
            ctrl.showCloseBtn = false;
            ctrl.saving = false;
            ctrl.miroBoardInvalid = false;
            ctrl.editorEnabled = false;
            ctrl.currMiroBoardLink = ctrl.origMiroBoardLink = '';
            ctrl.smartorg.getInavMiroBoard(ctrl.node['_id']).then(function (res) {
                var validatedHTML = ctrl.validateMiroBoard(res, '-6658,-363,4016,2544');
                if (validatedHTML) {
                    $('#iframe').html(validatedHTML);
                }
                else {
                    $('#iframe').html('');
                }
            })["catch"](function (err) {
                ctrl.showAlert('danger', 'Error!', err.message);
                $('#iframe').html('');
                ctrl.origMiroBoardLink = undefined;
            });
            $scope.$emit('workbench:loading', { 'load': false });
        });
        $timeout();
    }
    ScoringComponent.prototype.initImpactScoringImgComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
    };
    ScoringComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.readOnly = ctrl.node.permissions === "r";
        ctrl.origMiroBoardLink = ctrl.currMiroBoardLink = "";
        ctrl.editorEnabled = false;
        ctrl.showCloseBtn = false;
        ctrl.saving = false;
        ctrl.miroBoardInvalid = false;
        $('#iframe').html('');
        // ctrl.smartorg.getInavMiroBoard(ctrl.node['_id']).then((res) => {
        //     const validatedHTML = ctrl.validateMiroBoard(res);
        //     if (validatedHTML) {
        //         ctrl.origMiroBoardLink = validatedHTML;
        //         ctrl.currMiroBoardLink = ctrl.origMiroBoardLink;
        //         ctrl.updateMiroBoardID();
        //         $('#iframe').html(validatedHTML);
        //     }
        //     ctrl.editorEnabled = (typeof ctrl.currMiroBoardLink === "undefined" || ctrl.currMiroBoardLink === '');
        //     ctrl.menu = ctrl.getMenu();
        //     ctrl.$scope.$apply();
        // }).catch((err) => {
        //     ctrl.showAlert('danger', 'Error!', err.message);
        //     ctrl.origMiroBoardLink = undefined;
        // });
        //
        // window.addEventListener('message',function(event) {
        //     if(event.origin !== 'https://oasis-northern-persimmon.glitch.me' || event.data.board !== ctrl.currMiroBoardID) {
        //         return;
        //     }
        //     console.log('received response from ' + event.origin);
        //     ctrl.getIssueDetails(event.data.data);
        // },false);
    };
    ScoringComponent.prototype.updateMiroBoardID = function () {
        var ctrl = this;
        ctrl.currMiroBoardLink.split(" ").forEach(function (part) {
            if (part.startsWith("src=")) {
                ctrl.currMiroBoardID = part.substring(part.indexOf("live-embed/") + 11, part.indexOf("?") - 1);
                return;
            }
        });
    };
    ScoringComponent.prototype.getIssueDetails = function (issueData) {
        issueData.forEach(function (issue) {
            if (!('prevScore' in issue)) {
                issue['prevScore'] = issue['prevIG'] * issue['prevIM'];
            }
        });
        var ctrl = this;
        ctrl.smartorg.saveInavIssueDataFromMiro(issueData, ctrl.node['_id'], ctrl.node['data']).then(function (res) {
            if (res) {
                ctrl.showAlert('success', 'Saved!', 'Issue score saved.');
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    ScoringComponent.prototype.getMenu = function () {
        var ctrl = this;
        return [
            {
                'name': 'Edit',
                'class': 'btn btn-xs btn-primary',
                'show': function () {
                    return !ctrl.editorEnabled && !ctrl.readOnly;
                },
                'callback': function () {
                    ctrl.editorEnabled = true;
                    ctrl.showCloseBtn = true;
                    ctrl.currMiroBoardLink = ctrl.origMiroBoardLink;
                }
            }, {
                'name': 'Save',
                'class': 'btn btn-xs btn-danger',
                'show': function () {
                    return ctrl.editorEnabled && ctrl.currMiroBoardLink != ctrl.origMiroBoardLink && !ctrl.saving;
                },
                'callback': function () {
                    var validatedHTML = ctrl.validateMiroBoard(ctrl.currMiroBoardLink);
                    if (!validatedHTML) {
                        ctrl.miroBoardInvalid = true;
                        angular.element('#miroLink').focus();
                        return;
                    }
                    ctrl.saving = true;
                    ctrl.miroBoardInvalid = false;
                    $('#iframe').html(validatedHTML);
                    ctrl.$timeout(function () {
                        ctrl.smartorg.saveInavMiroBoard(ctrl.node._id, validatedHTML).then(function (res) {
                            if (res) {
                                ctrl.showAlert('success', 'Saved!', 'Miro board is saved.');
                                ctrl.editorEnabled = validatedHTML === '';
                                ctrl.origMiroBoardLink = ctrl.currMiroBoardLink = validatedHTML;
                                ctrl.updateMiroBoardID();
                                ctrl.showCloseBtn = validatedHTML !== '';
                                ctrl.saving = false;
                                ctrl.$timeout();
                                ctrl.$scope.$apply();
                            }
                            else {
                                ctrl.showAlert('danger', 'Error!', res.message);
                                ctrl.saving = false;
                            }
                        })["catch"](function (err) {
                            ctrl.showAlert('danger', 'Error!', err.message);
                            ctrl.saving = false;
                        });
                    }, 500);
                }
            }, {
                'name': 'Reset',
                'class': 'btn btn-xs btn-primary',
                'show': function () {
                    return ctrl.editorEnabled && ctrl.currMiroBoardLink !== ctrl.origMiroBoardLink && !ctrl.saving;
                },
                'callback': function () {
                    ctrl.editorEnabled = true;
                    ctrl.miroBoardInvalid = false;
                    ctrl.currMiroBoardLink = ctrl.origMiroBoardLink;
                    ctrl.showCloseBtn = typeof ctrl.origMiroBoardLink !== "undefined" || ctrl.origMiroBoardLink !== '';
                }
            }, {
                'name': '',
                'class': 'btn btn-xs btn-danger',
                'icon': 'fa fa-spinner fa-spin fa-fw',
                'show': function () {
                    return ctrl.saving;
                }
            }, {
                'name': 'Close',
                'class': 'btn btn-xs btn-primary',
                'show': function () {
                    return ctrl.editorEnabled && ctrl.showCloseBtn;
                },
                'callback': function () {
                    ctrl.editorEnabled = false;
                    ctrl.miroBoardInvalid = false;
                    ctrl.showCloseBtn = false;
                    ctrl.currMiroBoardLink = ctrl.origMiroBoardLink;
                }
            }
        ];
    };
    ScoringComponent.prototype.validateMiroBoard = function (html, viewport) {
        if (viewport === void 0) { viewport = '-2511,-1469,9378,5276'; }
        var doc = document.createElement('div');
        doc.innerHTML = html;
        var iframe = doc.firstElementChild;
        if (doc.childElementCount !== 1 || !iframe || iframe.tagName !== 'IFRAME' ||
            !iframe['src'].startsWith('https://miro.com/app/live-embed/')) {
            return '';
        }
        var currIframe = document.getElementById('iframe').firstElementChild;
        // if no original iframe (first load) or src changed (board redirected), reset the iframe size
        if (!currIframe || (currIframe.tagName === 'IFRAME' && currIframe['src'] !== iframe['src'])) {
            iframe['width'] = 1200;
            iframe['height'] = 600;
        }
        // preset viewport and autoplay
        var urlLen = iframe['src'].indexOf('?');
        var url = iframe['src'].substring(0, urlLen);
        iframe['src'] = url + '?' + 'moveToViewport=' + viewport + '&embedAutoplay=true';
        return iframe.outerHTML;
    };
    ScoringComponent.prototype.showTornado = function (args) {
        var ctrl = this;
        var portfolioName = args.treeName;
        ctrl.inputData = args.config.data.inputData.TornadoDistOutputs;
        ctrl.maxBars = args.config.data.maxBars;
        ctrl.nodeName = args.config.data.nodeName;
        ctrl.decimals = 2;
        ctrl.timestampMode = 'lastRecalc';
        if (localStorage.getItem('PortfolioConfig') &&
            portfolioName in JSON.parse(localStorage.getItem('PortfolioConfig'))) {
            var portfolioConfig = JSON.parse(localStorage.getItem('PortfolioConfig'))[portfolioName];
            ctrl.decimals = portfolioConfig['chart']['decimals'];
            ctrl.showTooltip = portfolioConfig['chart']['showTooltip'] != "false";
            if (portfolioConfig['timestamp']) {
                ctrl.timestampMode = portfolioConfig['timestamp']['timestampMode'];
            }
        }
        else if (args.config.data.settings) {
            ctrl.decimals = args.config.data.settings.decimals;
            ctrl.showTooltip = args.config.data.settings.showTooltip != "false";
            ctrl.timestampMode = args.config.data.settings.timestampMode || 'lastRecalc';
        }
        if (ctrl.decimals == "Default") {
            if (args.config.data.settings.defaultPrecision) {
                ctrl.decimals = args.config.data.settings.defaultPrecision;
            }
        }
        ctrl.timestamp = ctrl.timestampMode === 'lastRecalc' ? args.nodeLastRecalc : null;
        if (args.config.data.shadowInputData) {
            ctrl.shadowInputData = args.config.data.shadowInputData.TornadoDistOutputs;
            ctrl.shadowNodeName = args.config.data.shadowNodeName;
        }
        else {
            ctrl.shadowInputData = undefined;
            ctrl.shadowNodeName = null;
        }
        var index = 0;
        if (ctrl.selectedInputDataOnReload &&
            (ctrl.actionMenuItem == ctrl.actionMenuItemOnReload)) {
            for (var i = 0; i < ctrl.inputData.length; i++) {
                if (ctrl.selectedInputDataOnReload.Display == ctrl.inputData[i].Display) {
                    index = i;
                    break;
                }
            }
        }
        ctrl.selectedInputData = ctrl.inputData[index];
        ctrl.selectedShadowInputData = (!ctrl.shadowInputData) ? null : ctrl.shadowInputData[index];
        ctrl.drawTornadoGraph();
        ctrl.appStructure = args.config.data.appStructure;
        ctrl.dataStructure = args.config.data.dataStructure;
        ctrl.firstFactorActionNameItem = new tornado_logic_1["default"]().getFirstFactorActionNameFromInputs(ctrl.appStructure, ctrl.dataStructure, ctrl.selectedInputData.Table[0].Factor);
        ctrl.firstFactorActionName = ctrl.firstFactorActionNameItem.Display;
        ctrl.firstFactorActionID = ctrl.firstFactorActionNameItem.ID;
        ctrl.gotoInput = function () {
            ctrl.$emit("workbench:redirect", {
                menu: ctrl.firstFactorActionID
            });
        };
        ctrl.currentTornadoDepth = new tornado_logic_1["default"]().getCurrentTornadoDepth(ctrl.appStructure);
        setTimeout(function () {
            ctrl.$scope.$apply();
        }, 0);
    };
    ;
    ScoringComponent.prototype.drawTornadoGraph = function () {
        var ctrl = this;
        var chartMaker = new tornado_chart_maker_1["default"](ctrl.selectedInputData, ctrl.selectedShadowInputData, ctrl.shadowNodeName, ctrl.nodeName, ctrl.maxBars, ctrl.showTooltip, ctrl.decimals, ctrl.timestamp);
        chartMaker.plot();
    };
    ;
    return ScoringComponent;
}());
angular.module('smartorg.r6.acts.scoring', []).component('scoring', {
    template: require('./scoring.component.html'),
    controller: ScoringComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.scoring';
//# sourceMappingURL=scoring.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/scoring/scoring.component.js